import React from 'react'
import {ReportColumn} from '../types'

interface ReportTotalsProps {
  columns: ReportColumn[]
  totals: Record<string, any>
}

const ReportTotals: React.FC<ReportTotalsProps> = ({columns, totals}) => {
  const formatValue = (value: any, column: ReportColumn) => {
    if (value === null || value === undefined) return '-'

    switch (column.type) {
      case 'currency':
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 2,
        }).format(Number(value))

      case 'number':
        return new Intl.NumberFormat('en-IN').format(Number(value))

      case 'percentage':
        return `${Number(value).toFixed(2)}%`

      default:
        return String(value)
    }
  }

  const isDangerColumn = (field: string) => {
    const lowerField = field.toLowerCase()
    return (
      lowerField.includes('outstanding') ||
      lowerField.includes('due') ||
      lowerField.includes('overdue') ||
      lowerField.includes('payable')
    )
  }

  const isSuccessColumn = (field: string) => {
    const lowerField = field.toLowerCase()
    return (
      lowerField.includes('collected') ||
      lowerField.includes('received') ||
      lowerField.includes('totalsales')
    )
  }

  const isInfoColumn = (field: string) => {
    const lowerField = field.toLowerCase()
    return (
      (lowerField.includes('paid') || lowerField.includes('adjusted')) &&
      !lowerField.includes('payable')
    )
  }

  const getColumnTheme = (field: string) => {
    if (isDangerColumn(field))
      return {border: 'border-danger', text: 'text-danger', color: '#f1416c'}
    if (isSuccessColumn(field))
      return {border: 'border-success', text: 'text-success', color: '#50cd89'}
    if (isInfoColumn(field)) return {border: 'border-info', text: 'text-info', color: '#009ef7'}
    return {border: 'border-primary', text: 'text-primary', color: '#009ef7'}
  }

  const columnsWithTotals = columns.filter((col) => col.includeInTotals && col.visible)

  if (columnsWithTotals.length === 0) return null

  return (
    <div className='bg-light-primary rounded p-4 mt-4'>
      <h6 className='fw-bold mb-3 text-primary'>
        <i className='bi bi-calculator me-2'></i>
        Report Totals
      </h6>
      <div className='row g-3'>
        {columnsWithTotals.map((col) => {
          const theme = getColumnTheme(col.field)
          const hasValue = totals[col.field] && Number(totals[col.field]) > 0
          return (
            <div key={col.field} className='col-6 col-md-3'>
              <div
                className={`border ${theme.border} border-dashed rounded p-3 text-center`}
                style={{backgroundColor: 'var(--bs-body-bg)'}}
              >
                <div className={`fs-7 mb-1 ${theme.text}`} style={{opacity: 0.8}}>
                  {col.displayName}
                </div>
                <div
                  className='fs-3 fw-bold'
                  style={{color: hasValue ? theme.color : '#a1a5b7'}}
                >
                  {formatValue(totals[col.field], col)}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ReportTotals
